var map = {
	"./beige/akzonobel.svg": 2644,
	"./blue/akzonobel.svg": 2645,
	"./cetabever/akzonobel.svg": 2646,
	"./heritage/akzonobel.svg": 2647,
	"./painters/akzonobel.svg": 2648,
	"./woodcare/akzonobel.svg": 2649
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;



//////////////////
// WEBPACK FOOTER
// ./shared/components/Header/assets ^\.\/.*\/akzonobel\.svg$
// module id = 629
// module chunks = 0